const PESQUISA = {
    PAGINACAO_DEFAULT: 10,
    PAGINACAO_MINIMA: 1,
    START_MINIMO: 0,
    SEM_RESULTADO: 0,
    MENSAGEM_SEM_RESULTADO: 'Nenhum resultado encontrado'
};

const SITUACAO_EXAME = {
    VALIDO: 'V',
    INVALIDO: 'I'
};

const SITUACAO_LAUDO = {
    COM_LAUDO: 'S',
    TEMPORARIO: 'T',
    SEM_LAUDO: 'N',
    EM_EMISSAO: 'E',
    AGUARDANDO_COMPLEMENTO: 'A',
    AGUARDANDO_ASSINATURA_DIGITAL: 'G'
};

const PERFIL = {
    MEDICO_SOLICITANTE: 'medicoSolicitante',
    MEDICO_LAUDADOR: 'medicoLaudador',
    MEDICO_RESIDENTE: 'medicoResidente',
    MEDICO_EXECUTOR: 'medicoExecutor',
    MEDICO_VISUALIZADOR: 'medicoVisualizador',
    ADMINISTRADOR: 'administrador',
    ADMINISTRADOR_ESTADUAL: 'adminEstadual',
    ADMINISTRADOR_LOCAL: 'adminLocal',
    TECNICO: 'tecnico',
    REGULADOR_EXAME: 'reguladorExame',
    VISUALIZADOR: 'visualizador',
    VISUALIZADOR_REDE: 'visualizadorRede',
    PACIENTE: 'paciente'
};

const PERMISSAO = {
    ACESSAR_HISTORICO_EXAMES: 'EXAMES_ACESSAR_HIST_EXAMES',
    ADICIONAR_ANEXO: 'EXAMES_ADICIONAR_ANEXO',
    CADASTRAR_MODELO_LAUDO: 'EXAMES_CAD_MODELO_LAUDO',
    DIRECIONAR_EXAME: 'EXAMES_DIRECIONAR_EXAME',
    DOWNLOAD_EXAME: 'EXAMES_DOWNLOAD_EXAME',
    EXAMES: 'EXAMES_EXAMES',
    EXCLUIR_MODELO_LAUDO: 'EXAMES_EXCLUIR_MODELO_LAUDO',
    HISTORICO_PACIENTE: 'EXAMES_HISTORICO_PACIENTE',
    INSERIR_INDICACAO_CLINICA: 'EXAMES_INSERIR_IND_CLINICA',
    INVALIDAR_EXAME: 'EXAMES_INVALIDAR_EXAME',
    INVALIDAR_EXAME_EMISSAO_LAUDO: 'EXAMES_INV_EXAME_EM_LAUDO',
    LAUDO_DEFINITIVO: 'EXAMES_LAUDAR_EXAME',
    LAUDO_TEMPORARIO: 'EXAMES_LAUDO_TEMPORARIO',
    VISUALIZ_INDICACAO_CLINICA: 'EXAMES_VISUALIZ_IND_CLINICA',
    VISUALIZAR_EXAME: 'EXAMES_VISUALIZACAO',
    VISUALIZAR_IMAGEM: 'EXAMES_VISUALIZAR_IMAGEM',
    VISUALIZAR_MODELO_LAUDO: 'EXAMES_VIS_MODELO_LAUDO',
    VISUALIZAR_WORKLIST: 'EXAMES_VISUALIZAR_WORKLIST',
    ENVIAR_EXAME_WORKLIST: 'EXAMES_ENVIA_EXAME_WORKLIST',
    ASSINATURA_DIGITAL: 'EXAMES_ASSINATURA_DIGITAL',
    COMPLETAR_CADASTRO: 'EXAMES_COMPLETAR_CADASTRO'
};

const TIPO_CONTATO = {
    TELEFONE_RESIDENCIAL: 1,
    TELEFONE_CELULAR: 2,
    TELEFONE_COMERCIAL: 3,
    EMAIL: 4,
    FAX: 5,
    OUTRO: 6
};

const MODULOS_EXAME = {
    DERMATOLOGIA: {
        SIGLA: 'VLP',
        DESCRICAO: 'TELEDERMATO'
    },
    ELETROCARDIOGRAFIA: {
        SIGLA: 'ECG',
        DESCRICAO: 'ELETROCARDIOGRAFIA'
    }
};

const LOG = {
    EMERG: 0,
    ALERT: 1,
    CRIT: 2,
    ERR: 3,
    WARN: 4,
    NOTICE: 5,
    INFO: 6,
    DEBUG: 7,

    // ECG
    ECG_SORTEAR_PROXIMO_EXAME_LAUDO: 'ECG_SORTEAR_PROXIMO_EXAME_LAUDO',

    // POLISSONOGRAFIA
    POLISSONOGRAFIA_SOLICITAR: 'POLISSONOGRAFIA_SOLICITAR',
    POLISSONOGRAFIA_ERRO_SOLICITAR: 'POLISSONOGRAFIA_ERRO_SOLICITAR',

    // RETINOGRAFIA
    RETINOGRAFIA_SOLICITAR: 'RETINOGRAFIA_SOLICITAR',
    RETINOGRAFIA_ERRO_SOLICITAR: 'RETINOGRAFIA_ERRO_SOLICITAR',

    // EXAMES
    ACESSO_EXAME_PROTOCOLO: 'STT_WEB_ACESSO_EXAME_PROTOCOLO',
    ACESSO_EXAME_INTERNO: 'STT_WEB_ACESSO_EXAME_INTERNO',
    ERRO_EXCLUIR_IMAGEM_EXAME: 'STT_WEB_ERRO_EXCLUIR_IMAGEM_EXAME',
    EXCLUIR_IMAGEM_EXAME: 'STT_WEB_EXCLUIR_IMAGEM_EXAME',
    ENVIO_EXAME_INTERNO: 'STT_WEB_ENVIO_EXAME_INTERNO',
    ENVIO_EXAME_AGENDADO_INTERNO: 'STT_WEB_ENVIO_EXAME_AGENDADO_INTERNO',
    LOGIN: 'STT_WEB_LOGIN',
    LOGIN_ERRO: 'STT_WEB_LOGIN_ERRO',
    LOGIN_INATIVO: 'STT_WEB_LOGIN_INATIVO',
    TERMO_USO_ACEITO: 'STT2_TERMO_USO_ACEITO',
    WHATS_APP_GROUP: 'STT2_MENSAGEM_RECEBIDA',
    ATUALIZACAO_AUTORIZACAO_DIVULGACAO: 'STT2_ATUALIZACAO_AUTORIZACAO_DIVULGACAO',
    INTEGRACAO_LAUDO: 'INTEGRACAO_LAUDO',
    CARIMBO_TEMPO: 'STT_WEB_CARIMBO_TEMPO',
    ASSINATURA_DIGITAL: 'STT_WEB_ASSINATURA_DIGITAL',
    SORTEIO_EXAME: 'STT_WEB_SORTEIO_EXAME',
    EMISSAO_LAUDO: 'STT_WEB_EMISSAO_LAUDO',
    ERRO_EMISSAO_LAUDO: 'STT_WEB_ERRO_EMISSAO_LAUDO',
    ERRO_SERVICOS_MONITORADOS: 'STT_WEB_ERRO_SERVICOS_MONITORADOS',
    EXAME_INVALIDADO: 'STT_WEB_EXAME_INVALIDADO',
    PACIENTE_VINCULADO_EXAME: 'STT_WEB_PACIENTE_VINCULADO_EXAME',
    SOLICITANTE_VINCULADO_EXAME: 'STT_WEB_SOLICITANTE_VINCULADO_EXAME',
    EXAME_PRIORIZADO: 'STT_WEB_EXAME_PRIORIZADO',
    EXAME_IGNORADO: 'STT_WEB_EXAME_IGNORADO',
    EXAME_GERIR: 'STT_WEB_EXAME_GERIR',
    ERRO_EXAME_GERIR: 'STT_WEB_ERRO_EXAME_GERIR',
    ERRO_NOTIFICACAO_WS: 'ERRO_NOTIFICACAO_WS',
    REDE_TELEMEDICINA_ALTERADA: 'REDE_TELEMEDICINA_ALTERADA',

    //Tratamento fora de domicílio
    PENDENCIA_TFD: 'STT2_WEB_PENDENCIA_TFD',
    ERRO_PENDENCIA_TFD: 'STT2_WEB_ERRO_PENDENCIA_TFD',
    DEVOLUCAO_TFD: 'STT2_WEB_DEVOLUCAO_TFD',
    ERRO_DEVOLUCAO_TFD: 'STT2_WEB_ERRO_DEVOLUCAO_TFD',
    CANCELAMENTO_TFD: 'STT2_WEB_CANCELAMENTO_TFD',
    ERRO_CANCELAMENTO_TFD: 'STT2_WEB_ERRO_CANCELAMENTO_TFD',
    NEGACAO_TFD: 'STT2_WEB_NEGACAO_TFD',
    ERRO_NEGACAO_TFD: 'STT2_WEB_ERRO_NEGACAO_TFD',
    ARQUIVAMENTO_TFD: 'STT2_WEB_ARQUIVAMENTO_TFD',
    ERRO_ARQUIVAMENTO_TFD: 'STT2_WEB_ERRO_ARQUIVAMENTO_TFD',
    ENCAMINHAMENTO_TFD: 'STT2_WEB_ENCAMINHAMENTO_TFD',
    ERRO_ENCAMINHAMENTO_TFD: 'STT2_WEB_ERRO_ENCAMINHAMENTO_TFD',
    CONFIRMAR_AG_CNRAC_TFD: 'STT2_WEB_CONFIRMAR_AG_CNRAC_TFD',
    ERRO_CONFIRMAR_AG_CNRAC_TFD: 'STT2_WEB_ERRO_CONFIRMAR_AG_CNRAC_TFD',
    CONFIRMAR_AGUARDO_AG_TFD: 'STT2_WEB_CONFIRMAR_AGUARDO_AG_TFD',
    ERRO_CONFIRMAR_AGUARDO_AG_TFD: 'STT2_WEB_ERRO_CONFIRMAR_AGUARDO_AG_TFD',
    CONFIRMAR_AGUARDO_PR_TFD: 'STT2_WEB_CONFIRMAR_AGUARDO_PR_TFD',
    ERRO_CONFIRMAR_AGUARDO_PR_TFD: 'STT2_WEB_ERRO_CONFIRMAR_AGUARDO_PR_TFD',
    CONFIRMAR_AG_TFD: 'STT2_WEB_CONFIRMAR_AG_TFD',
    ERRO_CONFIRMAR_AG_TFD: 'STT2_WEB_ERRO_CONFIRMAR_AG_TFD',
    AUTORIZAR_TFD: 'STT2_WEB_AUTORIZAR_TFD',
    ERRO_AUTORIZAR_TFD: 'STT2_WEB_ERRO_AUTORIZAR_TFD',
    ENCAMINHAR_REGULADOR_TFD: 'STT2_WEB_ENCAMINHAR_REGULADOR_TFD',
    ERRO_ENCAMINHAR_REGULADOR_TFD: 'STT2_WEB_ERRO_ENCAMINHAR_REGULADOR_TFD',
    ENCAMINHAR_AVALIADOR_TFD: 'STT2_WEB_ENCAMINHAR_AVALIADOR_TFD',
    ERRO_ENCAMINHAR_AVALIADOR_TFD: 'STT2_WEB_ERRO_ENCAMINHAR_AVALIADOR_TFD',
    INFORMAR_CNRAC_TFD: 'STT2_WEB_INFORMAR_CNRAC_TFD',
    ERRO_INFORMAR_CNRAC_TFD: 'STT2_WEB_ERRO_INFORMAR_CNRAC_TFD',
    INATIVAR_COMP_COMPARECIMENTO_TFD: 'STT2_WEB_INATIVAR_COMP_COMPARECIMENTO_TFD',
    ERRO_INATIVAR_COMP_COMPARECIMENTO_TFD: 'STT2_WEB_ERRO_INATIVAR_COMP_COMPARECIMENTO_TFD',
    INFORMAR_PROCEDIMENTO_SOLICITADO_TFD: 'STT2_WEB_INFORMAR_PROCEDIMENTO_SOLICITADO_TFD',
    ERRO_INFORMAR_PROCEDIMENTO_SOLICITADO_TFD: 'STT2_WEB_ERRO_INFORMAR_PROCEDIMENTO_SOLICITADO_TFD',
    REGULAR_TFD: 'STT2_WEB_REGULAR_TFD',
    ERRO_REGULAR_TFD: 'STT2_WEB_ERRO_REGULAR_TFD',
    VERIFICAR_CARIMBO_TEMPO_TFD: 'STT2_WEB_VERIFICAR_CARIMBO_TEMPO_TFD',
    ERRO_VERIFICAR_CARIMBO_TEMPO_TFD: 'STT2_WEB_ERRO_VERIFICAR_CARIMBO_TEMPO_TFD',
    INICIAR_NOVO_TFD: 'STT2_WEB_INICIAR_NOVO_TFD',
    ERRO_INICIAR_NOVO_TFD: 'STT2_WEB_ERRO_INICIAR_NOVO_TFD',
    EDITAR_TFD: 'STT2_WEB_EDITAR_TFD',
    ERRO_EDITAR_TFD: 'STT2_WEB_ERRO_EDITAR_TFD',
    LISTAR_SOLICITACOES_TFD: 'STT2_WEB_LISTAR_SOLICITACOES_TFD',
    ERRO_LISTAR_SOLICITACOES_TFD: 'STT2_WEB_ERRO_LISTAR_SOLICITACOES_TFD',
    PESQUISAR_SOLICITACAO_TFD: 'STT2_WEB_PESQUISAR_SOLICITACAO_TFD',
    ERRO_PESQUISAR_SOLICITACAO_TFD: 'STT2_WEB_ERRO_PESQUISAR_SOLICITACAO_TFD',
    BAIXAR_ARQUIVO_TFD: 'STT2_WEB_BAIXAR_ARQUIVO_TFD',
    ERRO_BAIXAR_ARQUIVO_TFD: 'STT2_WEB_ERRO_BAIXAR_ARQUIVO_TFD',
    BAIXAR_COMPROVANTE_COMPARECIMENDO_TFD: 'STT2_WEB_BAIXAR_COMPROVANTE_COMPARECIMENDO_TFD',
    ERRO_BAIXAR_COMPROVANTE_COMPARECIMENDO_TFD: 'STT2_WEB_ERRO_BAIXAR_COMPROVANTE_COMPARECIMENDO_TFD',
    IMPRIMIR_TFD: 'STT2_WEB_IMPRIMIR_TFD',
    ERRO_IMPRIMIR_TFD: 'STT2_WEB_ERRO_IMPRIMIR_TFD',
    ERRO_PESQUISA_CIDADES_ORIGEM_TFD: 'STT2_WEB_ERRO_PESQUISA_CIDADES_ORIGEM_TFD',
    ERRO_PESQUISA_TRANSPORTES_RECOMENDADOS_TFD: 'STT2_WEB_ERRO_PESQUISA_TRANSPORTES_RECOMENDADOS_TFD',
    ERRO_PESQUISA_CIDADES_AGENDADORAS_TFD: 'STT2_WEB_ERRO_PESQUISA_CIDADES_AGENDADORAS_TFD',
    ERRO_PESQUISA_CIDADES_AGENDADORAS_SOLICITANTE_TFD: 'STT2_WEB_ERRO_PESQUISA_CIDADES_AGENDADORAS_SOLICITANTE_TFD',
    ERRO_PESQUISA_TIPOS_ANEXO_TFD: 'STT2_WEB_ERRO_PESQUISA_TIPOS_ANEXO_TFD',
    ERRO_PESQUISA_PROCEDIMENTOS_SOLICITADOS_TFD: 'STT2_WEB_ERRO_PESQUISA_PROCEDIMENTOS_SOLICITADOS_TFD',
    ERRO_INICIAR_SOLICITACAO_TFD: 'STT2_WEB_ERRO_INICIAR_SOLICITACAO_TFD',
    ERRO_ENCAMINHAR_SOLICITACAO_TFD: 'STT2_WEB_ERRO_ENCAMINHAR_SOLICITACAO_TFD',
    ERRO_EDITAR_SOLICITACAO_TFD: 'STT2_WEB_ERRO_EDITAR_SOLICITACAO_TFD',
    ERRO_PESQUISA_MOTIVOS_DEVOLUCAO_TFD: 'STT2_WEB_ERRO_PESQUISA_MOTIVOS_DEVOLUCAO_TFD',
    ERRO_PESQUISA_MOTIVOS_CANCELAMENTO: 'STT2_WEB_ERRO_PESQUISA_MOTIVOS_CANCELAMENTO',
    ERRO_PESQUISA_AGENDAMENTO_TFD: 'STT2_WEB_ERRO_PESQUISA_AGENDAMENTO_TFD',
    ERRO_PESQUISA_DADOS_REGULADOR_TFD: 'ERRO_PESQUISA_DADOS_REGULADOR_TFD',
    ERRO_PESQUISA_DADOS_AVALIADOR_TFD: 'ERRO_PESQUISA_DADOS_AVALIADOR_TFD',
    ERRO_PESQUISA_TRANSPORTE_ID_TFD: 'STT2_WEB_ERRO_PESQUISA_TRANSPORTE_ID_TFD',
    ERRO_ANEXAR_COMPROVANTE_COMPARECIMENTO_TFD: 'STT2_WEB_ERRO_ANEXAR_COMPROVANTE_COMPARECIMENTO_TFD',
    ANEXAR_COMPROVANTE_COMPARECIMENTO_TFD: 'STT2_WEB_ANEXAR_COMPROVANTE_COMPARECIMENTO_TFD',
    TFD_PASSAGENS_PESQUISA: 'STT2_WEB_TFD_PASSAGENS_PESQUISA',
    TFD_PASSAGENS_ERRO_PESQUISA: 'STT2_WEB_TFD_PASSAGENS_ERRO_PESQUISA',
    TFD_PASSAGENS_IMPRESSAO: 'STT2_WEB_TFD_PASSAGENS_IMPRESSAO',
    TFD_PASSAGENS_ERRO_IMPRESSAO: 'STT2_WEB_TFD_PASSAGENS_ERRO_IMPRESSAO',
    TFD_PASSAGENS_PESQUISA_VINCULO: 'STT2_WEB_TFD_PASSAGENS_PESQUISA_VINCULO',
    TFD_PASSAGENS_ERRO_PESQUISA_VINCULO: 'STT2_WEB_TFD_PASSAGENS_ERRO_PESQUISA_VINCULO',
    TFD_PASSAGENS_PESQUISA_ANEXO: 'STT2_WEB_TFD_PASSAGENS_PESQUISA_ANEXO',
    TFD_PASSAGENS_ERRO_PESQUISA_ANEXO: 'STT2_WEB_TFD_PASSAGENS_ERRO_PESQUISA_ANEXO',
    TFD_PASSAGENS_PESQUISA_ACOMPANHANTE: 'STT2_WEB_TFD_PASSAGENS_PESQUISA_ACOMPANHANTE',
    TFD_PASSAGENS_ERRO_PESQUISA_ACOMPANHANTE: 'STT2_WEB_TFD_PASSAGENS_ERRO_PESQUISA_ACOMPANHANTE',
    TFD_PASSAGENS_VISUALIZACAO: 'STT2_WEB_TFD_PASSAGENS_VISUALIZACAO',
    TFD_PASSAGENS_ERRO_VISUALIZACAO: 'STT2_WEB_TFD_PASSAGENS_ERRO_VISUALIZACAO',
    TFD_PASSAGENS_PESQUISA_RASCUNHOS_ID_TFD: 'STT2_WEB_TFD_PASSAGENS_PESQUISA_RASCUNHOS_ID_TFD',
    TFD_PASSAGENS_ERRO_PESQUISA_RASCUNHOS_ID_TFD: 'STT2_WEB_TFD_PASSAGENS_ERRO_PESQUISA_RASCUNHOS_ID_TFD',
    TFD_PASSAGENS_ABERTURA: 'STT2_WEB_TFD_PASSAGENS_ABERTURA',
    TFD_PASSAGENS_ERRO_ABERTURA: 'STT2_WEB_TFD_PASSAGENS_ERRO_ABERTURA',
    TFD_PASSAGENS_ABRIR_ALTERACAO: 'STT2_WEB_TFD_PASSAGENS_ABRIR_ALTERACAO',
    TFD_PASSAGENS_ERRO_ABRIR_ALTERACAO: 'STT2_WEB_TFD_PASSAGENS_ERRO_ABRIR_ALTERACAO',
    TFD_PASSAGENS_NOVA_SOLICITACAO: 'STT2_WEB_TFD_PASSAGENS_NOVA_SOLICITACAO',
    TFD_PASSAGENS_ERRO_NOVA_SOLICITACAO: 'STT2_WEB_TFD_PASSAGENS_ERRO_NOVA_SOLICITACAO',
    TFD_PASSAGENS_PROCESSO_ESPELHO: 'STT2_WEB_TFD_PASSAGENS_PROCESSO_ESPELHO',
    TFD_PASSAGENS_ERRO_PROCESSO_ESPELHO: 'STT2_WEB_TFD_PASSAGENS_ERRO_PROCESSO_ESPELHO',
    TFD_PASSAGENS_SALVAR_PROCESSO: 'STT2_WEB_TFD_PASSAGENS_SALVAR_PROCESSO',
    TFD_PASSAGENS_ERRO_SALVAR_PROCESSO: 'STT2_WEB_TFD_PASSAGENS_ERRO_SALVAR_PROCESSO',
    TFD_PASSAGENS_OP_VOLTAR: 'STT2_WEB_TFD_PASSAGENS_OP_VOLTAR',
    TFD_PASSAGENS_ERRO_OP_VOLTAR: 'STT2_WEB_TFD_PASSAGENS_ERRO_OP_VOLTAR',
    TFD_PASSAGENS_OP_REABRIR: 'STT2_WEB_TFD_PASSAGENS_OP_REABRIR',
    TFD_PASSAGENS_ERRO_OP_REABRIR: 'STT2_WEB_TFD_PASSAGENS_ERRO_OP_REABRIR',
    TFD_PASSAGENS_OP_DEVOLVER: 'STT2_WEB_TFD_PASSAGENS_OP_DEVOLVER',
    TFD_PASSAGENS_ERRO_OP_DEVOLVER: 'STT2_WEB_TFD_PASSAGENS_ERRO_OP_DEVOLVER',
    TFD_PASSAGENS_OP_SUSPENDER: 'STT2_WEB_TFD_PASSAGENS_OP_SUSPENDER',
    TFD_PASSAGENS_ERRO_OP_SUSPENDER: 'STT2_WEB_TFD_PASSAGENS_ERRO_OP_SUSPENDER',
    TFD_PASSAGENS_OP_DOSSIE: 'STT2_WEB_TFD_PASSAGENS_OP_DOSSIE',
    TFD_PASSAGENS_ERRO_OP_DOSSIE: 'STT2_WEB_TFD_PASSAGENS_ERRO_OP_DOSSIE',
    TFD_PASSAGENS_OP_CANCELAR: 'STT2_WEB_TFD_PASSAGENS_OP_CANCELAR',
    TFD_PASSAGENS_ERRO_OP_CANCELAR: 'STT2_WEB_TFD_PASSAGENS_ERRO_OP_CANCELAR',
    TFD_PASSAGENS_OP_SEL_MOTORISTA: 'STT2_WEB_TFD_PASSAGENS_OP_SEL_MOTORISTA',
    TFD_PASSAGENS_ERRO_OP_SEL_MOTORISTA: 'STT2_WEB_TFD_PASSAGENS_ERRO_OP_SEL_MOTORISTA',
    TFD_PASSAGENS_OP_SEL_REGULADOR: 'STT2_WEB_TFD_PASSAGENS_OP_SEL_REGULADOR',
    TFD_PASSAGENS_ERRO_OP_SEL_REGULADOR: 'STT2_WEB_TFD_PASSAGENS_ERRO_OP_SEL_REGULADOR',
    TFD_PASSAGENS_OP_APROVAR: 'STT2_WEB_TFD_PASSAGENS_OP_APROVAR',
    TFD_PASSAGENS_ERRO_OP_APROVAR: 'STT2_WEB_TFD_PASSAGENS_ERRO_OP_APROVAR',
    TFD_PASSAGENS_OP_AUTORIZAR: 'STT2_WEB_TFD_PASSAGENS_OP_AUTORIZAR',
    TFD_PASSAGENS_ERRO_OP_AUTORIZAR: 'STT2_WEB_TFD_PASSAGENS_ERRO_OP_AUTORIZAR',
    TFD_PASSAGENS_OP_ARQUIVAR: 'STT2_WEB_TFD_PASSAGENS_OP_ARQUIVAR',
    TFD_PASSAGENS_ERRO_OP_ARQUIVAR: 'STT2_WEB_TFD_PASSAGENS_ERRO_OP_ARQUIVAR',
    TFD_PASSAGENS_OP_ANEXAR_COMPROVANTE: 'STT2_WEB_TFD_PASSAGENS_OP_ANEXAR_COMPROVANTE',
    TFD_PASSAGENS_ERRO_OP_ANEXAR_COMPROVANTE: 'STT2_WEB_TFD_PASSAGENS_ERRO_OP_ANEXAR_COMPROVANTE',
    TFD_PASSAGENS_OP_ENCAMINHAR_VIAGEM: 'STT2_WEB_TFD_PASSAGENS_OP_ENCAMINHAR_VIAGEM',
    TFD_PASSAGENS_ERRO_OP_ENCAMINHAR_VIAGEM: 'STT2_WEB_TFD_PASSAGENS_ERRO_OP_ENCAMINHAR_VIAGEM',
    TFD_PASSAGENS_ERRO_OP_CADASTRO_MOTORISTA: 'STT2_WEB_TFD_PASSAGENS_ERRO_OP_CADASTRO_MOTORISTA',
    TFD_PASSAGENS_OP_CADASTRO_MOTORISTA: 'STT2_WEB_TFD_PASSAGENS_OP_CADASTRO_MOTORISTA',
    TFD_PASSAGENS_ERRO_OP_CADASTRO_MOTIVO_CANCELAMENTO: 'STT2_WEB_TFD_PASSAGENS_ERRO_OP_CADASTRO_MOT_CANCEL',
    TFD_PASSAGENS_OP_CADASTRO_MOTIVO_CANCELAMENTO: 'STT2_WEB_TFD_PASSAGENS_OP_CADASTRO_MOT_CANCEL',

    // Itinerário terapêutico
    STT_WEB_ACESSO_EXAME_IT: 'STT_WEB_ACESSO_EXAME_IT',
    STT_WEB_AVALIACAO_EXAME_IT: 'STT_WEB_AVALIACAO_EXAME_IT',

    //ADMINISTRATIVO

    //Pesquisa de funcionários
    ADMINISTRATIVO_PESQUISA_FUNCIONARIOS: 'ADMINISTRATIVO_PESQUISA_FUNCIONARIOS',
    ADMINISTRATIVO_ERRO_PESQUISA_FUNCIONARIOS: 'ADMINISTRATIVO_ERRO_PESQUISA_FUNCIONARIOS',
    ADMINISTRATIVO_PESQUISA_FUNCIONARIO: 'ADMINISTRATIVO_PESQUISA_FUNCIONARIO',
    ADMINISTRATIVO_ERRO_PESQUISA_FUNCIONARIO: 'ADMINISTRATIVO_ERRO_PESQUISA_FUNCIONARIO',
    ADMINISTRATIVO_ERRO_PESQUISA_INSTITUICOES_ADMIN_LOCAL: 'ADMINISTRATIVO_ERRO_PESQUISA_INSTITUICOES_ADMIN_LOCAL',
    ADMINISTRATIVO_CADASTRAR_FUNCIONARIO: 'ADMINISTRATIVO_CADASTRAR_FUNCIONARIO',
    ADMINISTRATIVO_ALTERAR_AUTORIZACAO_DIVULGACAO_FUNC: 'ADMINISTRATIVO_ALTERAR_AUTORIZACAO_DIVULGACAO_FUNC',
    ADMINISTRATIVO_LIMPEZA_CACHE_USUARIO_ERRO: 'ADMINISTRATIVO_LIMPEZA_CACHE_USUARIO_ERRO',
    ADMINISTRATIVO_CADASTRAR_PERFIL: 'ADMINISTRATIVO_CADASTRAR_PERFIL',
    ADMINISTRATIVO_ERRO_CADASTRAR_FUNCIONARIO: 'ADMINISTRATIVO_ERRO_CADASTRAR_FUNCIONARIO',
    ADMINISTRATIVO_EXCLUIR_PERFIL: 'ADMINISTRATIVO_EXCLUIR_PERFIL',
    ADMINISTRATIVO_ERRO_EXCLUIR_PERFIL: 'ADMINISTRATIVO_ERRO_EXCLUIR_PERFIL',
    ADMINISTRATIVO_ERRO_CADASTRAR_PERFIL: 'ADMINISTRATIVO_ERRO_CADASTRAR_PERFIL',
    ADMINISTRATIVO_PESQUISA_FUNCIONARIO_CADSUS: 'ADMINISTRATIVO_PESQERRO_UISA_FUNCIONARIO_CADSUS',
    ADMINISTRATIVO_ERRO_PESQUISA_FUNCIONARIO_CADSUS: 'ADMINISTRATIVO_PESQUISA_FUNCIONARIO_CADSUS',
    ADMINISTRATIVO_ALTERACAO_SENHA_USUARIO: 'ADMINISTRATIVO_ALTERACAO_SENHA_USUARIO',
    ADMINISTRATIVO_ERRO_ALTERACAO_SENHA_USUARIO: 'ADMINISTRATIVO_ERRO_ALTERACAO_SENHA_USUARIO',
    ADMINISTRATIVO_ERRO_VERIFICACAO_LOGIN_DUPLICADO: 'ADMINISTRATIVO_ERRO_VERIFICACAO_LOGIN_DUPLICADO',
    ADMINISTRATIVO_ERRO_SALVAR_LOG_ALTERACAO_DADOS: 'ADMINISTRATIVO_ERRO_SALVAR_LOG_ALTERACAO_DADOS',
    ADMINISTRATIVO_ERRO_PESQUISA_PERFIS_SUPERIORES: 'ADMINISTRATIVO_ERRO_PESQUISA_PERFIS_SUPERIORES',

    ADMINISTRATIVO_CADASTRAR_CIDADE_REFRENCIA: 'ADMINISTRATIVO_CADASTRAR_CIDADE_REFRENCIA',
    ADMINISTRATIVO_ERRO_CADASTRAR_CIDADE_REFRENCIA: 'ADMINISTRATIVO_ERRO_CADASTRAR_CIDADE_REFRENCIA',

    ADMINISTRATIVO_PESQUISA_PERFIS: 'ADMINISTRATIVO_PESQUISA_PERFIS',
    ADMINISTRATIVO_ERRO_PESQUISA_PERFIS: 'ADMINISTRATIVO_ERRO_PESQUISA_PERFIS',

    ADMINISTRATIVO_PESQUISA_PONTOS: 'ADMINISTRATIVO_PESQUISA_PONTOS',
    ADMINISTRATIVO_ERRO_PESQUISA_PONTOS: 'ADMINISTRATIVO_ERRO_PESQUISA_PONTOS',
    ADMINISTRATIVO_CADASTRAR_PONTOS: 'ADMINISTRATIVO_CADASTRAR_PONTOS',
    ADMINISTRATIVO_ERRO_CADASTRAR_PONTOS: 'ADMINISTRATIVO_ERRO_CADASTRAR_PONTOS',

    ADMINISTRATIVO_PESQUISA_EQUIPES: 'ADMINISTRATIVO_PESQUISA_EQUIPES',
    ADMINISTRATIVO_ERRO_PESQUISA_EQUIPES: 'ADMINISTRATIVO_ERRO_PESQUISA_EQUIPES',

    ADMINISTRATIVO_PESQUISA_PERMISSOES: 'ADMINISTRATIVO_PESQUISA_PERMISSOES',
    ADMINISTRATIVO_ERRO_PESQUISA_PERMISSOES: 'ADMINISTRATIVO_ERRO_PESQUISA_PERMISSOES',

    ADMINISTRATIVO_CADASTRO_PERMISSOES_PERFIL: 'ADMINISTRATIVO_CADASTRO_PERMISSOES_PERFIL',
    ADMINISTRATIVO_ERRO_CADASTRO_PERMISSOES_PERFIL: 'ADMINISTRATIVO_ERRO_CADASTRO_PERMISSOES_PERFIL',

    ADMINISTRATIVO_PESQUISAR_LOG_FUNCIONARIO: 'ADMINISTRATIVO_PESQUISAR_LOG_FUNCIONARIO',
    ADMINISTRATIVO_PESQUISAR_LOG_USUARIO: 'ADMINISTRATIVO_PESQUISAR_LOG_USUARIO',

    //Motivos de invalidação de exame
    ADMINISTRATIVO_PESQUISA_MOTIVO_INVALIDACAO_EXAME: 'ADMINISTRATIVO_PESQUISA_MOTIVO_INVALIDACAO_EXAME',
    ADMINISTRATIVO_ERRO_PESQUISA_MOTIVO_INVALIDACAO_EXAME: 'ADMINISTRATIVO_ERRO_PESQUISA_MOTIVO_INVALIDA_EXAME',
    ADMINISTRATIVO_CADASTRAR_MOTIVO_INVALIDACAO_EXAME: 'ADMINISTRATIVO_CADASTRAR_MOTIVO_INVALIDACAO_EXAME',
    ADMINISTRATIVO_ERRO_CADASTRAR_MOTIVO_INVALIDACAO_EXAME: 'ADMINISTRATIVO_ERRO_CADASTRO_MOTIVO_INVALIDA_EXAME',

    //Materiais suporte
    ADMINISTRATIVO_PESQUISA_MATERIAIS_SUPORTE: 'ADMINISTRATIVO_PESQUISA_MATERIAIS_SUPORTE',
    ADMINISTRATIVO_ERRO_PESQUISA_MATERIAIS_SUPORTE: 'ADMINISTRATIVO_ERRO_PESQUISA_MATERIAIS_SUPORTE',
    ADMINISTRATIVO_CADASTRO_MATERIAIS_SUPORTE: 'ADMINISTRATIVO_CADASTRO_MATERIAIS_SUPORTE',
    ADMINISTRATIVO_ERRO_CADASTRO_MATERIAIS_SUPORTE: 'ADMINISTRATIVO_ERRO_CADASTRO_MATERIAIS_SUPORTE',
    ADMINISTRATIVO_ERRO_ACESSO_ANEXO_MATERIAIS_SUPORTE: 'ADMINISTRATIVO_ERRO_ACESSO_ANEXO_MATERIAIS_SUPORTE',

    // Auditoria
    ADMINISTRATIVO_PESQUISA_AUDITORIA: 'ADMINISTRATIVO_PESQUISA_AUDITORIA',
    ADMINISTRATIVO_ERRO_PESQUISA_AUDITORIA: 'ADMINISTRATIVO_ERRO_PESQUISA_AUDITORIA',
    ADMINISTRATIVO_PESQUISA_DETALHES_HTTP_AUDITORIA: 'ADMINISTRATIVO_PESQUISA_DETALHES_HTTP_AUDITORIA',
    ADMINISTRATIVO_ERRO_PESQUISA_DETALHES_HTTP_AUDITORIA: 'ADMINISTRATIVO_ERRO_PESQUISA_DETALHES_HTTP_AUDITORIA',


    // INSTITUIÇÕES
    ADMINISTRATIVO_PESQUISA_INSTITUICAO: 'ADMINISTRATIVO_PESQUISA_INSTITUICAO',
    ADMINISTRATIVO_ERRO_PESQUISA_INSTITUICAO: 'ADMINISTRATIVO_ERRO_PESQUISA_INSTITUICAO',
    ADMINISTRATIVO_CADASTRAR_INSTITUICAO: 'ADMINISTRATIVO_CADASTRAR_INTITUICAO',
    ADMINISTRATIVO_ERRO_CADASTRAR_INSTITUICAO: 'ADMINISTRATIVO_ERRO_CADASTRAR_INSTITUICAO',
    ADMINISTRATIVO_BAIXAR_MATERIAL: 'ADMINISTRATIVO_BAIXAR_MATERIAL',

    ADMINISTRATIVO_PESQUISA_ACESSO_INSTITUICAO: 'ADMINISTRATIVO_PESQUISA_ACESSO_INSTITUICAO',
    ADMINISTRATIVO_ERRO_PESQUISA_ACESSO_INSTITUICAO: 'ADMINISTRATIVO_ERRO_PESQUISA_ACESSO_INSTITUICAO',
    ADMINISTRATIVO_APROVAR_ACESSO_INSTITUICAO: 'ADMINISTRATIVO_APROVAR_ACESSO_INSTITUICAO',
    ADMINISTRATIVO_ERRO_APROVAR_ACESSO_INSTITUICAO: 'ADMINISTRATIVO_ERRO_APROVAR_ACESSO_INSTITUICAO',
    ADMINISTRATIVO_REJEITAR_ACESSO_INSTITUICAO: 'ADMINISTRATIVO_REJEITAR_ACESSO_INSTITUICAO',
    ADMINISTRATIVO_ERRO_REJEITAR_ACESSO_INSTITUICAO: 'ADMINISTRATIVO_ERRO_REJEITAR_ACESSO_INSTITUICAO',

    // TELECONSULTORIAS
    TELECONSULTORIAS_ERRO_ACESSO_ANEXO: 'TELECONSULTORIAS_ERRO_ACESSO_ANEXO',
    TELECONSULTORIAS_ACESSO_CC_POR_ID: 'TELECONSULTORIAS_ACESSO_CC_POR_ID',
    TELECONSULTORIAS_ERRO_ACESSO_CC_POR_ID: 'TELECONSULTORIAS_ERRO_ACESSO_CC_POR_ID',
    TELECONSULTORIAS_ACESSO_SOLICITACAO_POR_ID: 'TELECONSULTORIAS_ACESSO_SOLICITACAO_POR_ID',
    TELECONSULTORIAS_ERRO_ACESSO_SOLICITACAO_POR_ID: 'TELECONSULTORIAS_ERRO_ACESSO_SOLICITACAO_POR_ID',
    TELECONSULTORIAS_ACESSO_0800_POR_ID: 'TELECONSULTORIAS_ACESSO_0800_POR_ID',
    TELECONSULTORIAS_ERRO_ACESSO_0800_POR_ID: 'TELECONSULTORIAS_ERRO_ACESSO_0800_POR_ID',
    TELECONSULTORIAS_NOVA_SOLICITACAO: 'TELECONSULTORIAS_NOVA_SOLICITACAO',
    TELECONSULTORIAS_ERRO_NOVA_SOLICITACAO: 'TELECONSULTORIAS_ERRO_NOVA_SOLICITACAO',
    TELECONSULTORIAS_SALVAR_SOLICITACAO: 'TELECONSULTORIAS_SALVAR_SOLICITACAO',
    TELECONSULTORIAS_ERRO_SALVAR_SOLICITACAO: 'TELECONSULTORIAS_ERRO_SALVAR_SOLICITACAO',
    TELECONSULTORIAS_ERRO_AUTORREGULACAO: 'TELECONSULTORIAS_ERRO_AUTORREGULACAO',
    TELECONSULTORIAS_ERRO_SALVAR_MOVIMENTACAO: 'TELECONSULTORIAS_ERRO_SALVAR_MOVIMENTACAO',
    TELECONSULTORIAS_ERRO_INVALIDACAO: 'TELECONSULTORIAS_ERRO_INVALIDACAO',
    TELECONSULTORIAS_INVALIDACAO: 'TELECONSULTORIAS_INVALIDACAO',
    TELECONSULTORIAS_REGULACAO: 'TELECONSULTORIAS_REGULACAO',
    TELECONSULTORIAS_ERRO_REGULACAO: 'TELECONSULTORIAS_ERRO_REGULACAO',
    TELECONSULTORIAS_REGULACAO_MULTIPLA: 'TELECONSULTORIAS_REGULACAO_MULTIPLA',
    TELECONSULTORIAS_ERRO_REGULACAO_MULTIPLA: 'TELECONSULTORIAS_ERRO_REGULACAO_MULTIPLA',
    TELECONSULTORIAS_REGULACAO_TELE_SECUNDARIO: 'TELECONSULTORIAS_REGULACAO_TELE_SECUNDARIO',
    TELECONSULTORIAS_ERRO_REGULACAO_TELE_SECUNDARIO: 'TELECONSULTORIAS_ERRO_REGULACAO_TELE_SECUNDARIO',
    TELECONSULTORIAS_REGULACAO_REENCAMINHAMENTO: 'TELECONSULTORIAS_REGULACAO_REENCAMINHAMENTO',
    TELECONSULTORIAS_ERRO_APROVACAO: 'TELECONSULTORIAS_ERRO_APROVACAO',
    TELECONSULTORIAS_APROVACAO: 'TELECONSULTORIAS_APROVACAO',
    TELECONSULTORIAS_ERRO_ENVIO_EMAIL: 'TELECONSULTORIAS_ERRO_ENVIO_EMAIL',
    TELECONSULTORIAS_ERRO_RESPOSTA: 'TELECONSULTORIAS_ERRO_RESPOSTA',
    TELECONSULTORIAS_RESPOSTA: 'TELECONSULTORIAS_RESPOSTA',
    TELECONSULTORIAS_ERRO_RESPOSTA_SECUNDARIA: 'TELECONSULTORIAS_ERRO_RESPOSTA_SECUNDARIA',
    TELECONSULTORIAS_RESPOSTA_SECUNDARIA: 'TELECONSULTORIAS_RESPOSTA_SECUNDARIA',
    TELECONSULTORIAS_ERRO_DEVOLUCAO: 'TELECONSULTORIAS_ERRO_DEVOLUCAO',
    TELECONSULTORIAS_DEVOLUCAO: 'TELECONSULTORIAS_DEVOLUCAO',
    TELECONSULTORIAS_ERRO_AVALIACAO: 'TELECONSULTORIAS_ERRO_AVALIACAO',
    TELECONSULTORIAS_AVALIACAO: 'TELECONSULTORIAS_AVALIACAO',
    TELECONSULTORIAS_ERRO_REPLICA: 'TELECONSULTORIAS_ERRO_REPLICA',
    TELECONSULTORIAS_REPLICA: 'TELECONSULTORIAS_REPLICA',
    TELECONSULTORIAS_ERRO_TREPLICA: 'TELECONSULTORIAS_ERRO_TREPLICA',
    TELECONSULTORIAS_TREPLICA: 'TELECONSULTORIAS_TREPLICA',
    TELECONSULTORIAS_ERRO_FINALIZACAO_ADMINISTRATIVA: 'TELECONSULTORIAS_ERRO_FINALIZACAO_ADMINISTRATIVA',
    TELECONSULTORIAS_FINALIZACAO_ADMINISTRATIVA: 'TELECONSULTORIAS_FINALIZACAO_ADMINISTRATIVA',
    TELECONSULTORIAS_ERRO_ALTERAR_CLASSIFICACAO: 'TELECONSULTORIAS_ERRO_ALTERAR_CLASSIFICACAO',
    TELECONSULTORIAS_ALTERAR_CLASSIFICACAO: 'TELECONSULTORIAS_ALTERAR_CLASSIFICACAO',
    TELECONSULTORIAS_ERRO_ALTERAR_TELECONSULTOR: 'TELECONSULTORIAS_ERRO_ALTERAR_TELECONSULTOR',
    TELECONSULTORIAS_ALTERAR_TELECONSULTOR: 'TELECONSULTORIAS_ALTERAR_TELECONSULTOR',
    TELECONSULTORIAS_ERRO_ALTERAR_CLASSIFICACAO_CIDADE: 'TELECONSULTORIAS_ERRO_ALTERAR_CLASSIFICACAO_CIDADE',
    TELECONSULTORIAS_ALTERAR_CLASSIFICACAO_CIDADE: 'TELECONSULTORIAS_ALTERAR_CLASSIFICACAO_CIDADE',
    TELECONSULTORIAS_ERRO_ALTERAR_REGIAO_CIDADE: 'TELECONSULTORIAS_ERRO_ALTERAR_REGIAO_CIDADE',
    TELECONSULTORIAS_ALTERAR_REGIAO_CIDADE: 'TELECONSULTORIAS_ALTERAR_REGIAO_CIDADE',
    TELECONSULTORIAS_ERRO_ALTERAR_SITUACAO_REGIAO: 'TELECONSULTORIAS_ERRO_ALTERAR_SITUACAO_REGIAO',
    TELECONSULTORIAS_ALTERAR_SITUACAO_REGIAO: 'TELECONSULTORIAS_ALTERAR_SITUACAO_REGIAO',
    TELECONSULTORIAS_ERRO_SALVAR_SITUACAO_REGIAO: 'TELECONSULTORIAS_ERRO_SALVAR_SITUACAO_REGIAO',
    TELECONSULTORIAS_SALVAR_ATIVIDADE_REGIAO: 'TELECONSULTORIAS_SALVAR_ATIVIDADE_REGIAO',
    TELECONSULTORIAS_ERRO_SALVAR_ATIVIDADE_REGIAO: 'TELECONSULTORIAS_ERRO_SALVAR_ATIVIDADE_REGIAO',
    TELECONSULTORIAS_SALVAR_SITUACAO_REGIAO: 'TELECONSULTORIAS_SALVAR_SITUACAO_REGIAO',
    TELECONSULTORIAS_ERRO_ALTERAR_REGIAO_ANEXO: 'TELECONSULTORIAS_ERRO_ALTERAR_REGIAO_ANEXO',
    TELECONSULTORIAS_ALTERAR_REGIAO_ANEXO: 'TELECONSULTORIAS_ALTERAR_REGIAO_ANEXO',
    TELECONSULTORIAS_ERRO_EXCLUIR_RESTRICAO_ESPEC: 'TELECONSULTORIAS_ERRO_EXCLUIR_RESTRICAO_ESPEC',
    TELECONSULTORIAS_EXCLUIR_RESTRICAO_ESPECIFICACAO: 'TELECONSULTORIAS_EXCLUIR_RESTRICAO_ESPECIFICACAO',
    TELECONSULTORIAS_ERRO_SALVAR_RESTRICAO_ESPEC: 'TELECONSULTORIAS_ERRO_SALVAR_RESTRICAO_ESPEC',
    TELECONSULTORIAS_SALVAR_RESTRICAO_ESPECIFICACAO: 'TELECONSULTORIAS_SALVAR_RESTRICAO_ESPECIFICACAO',
    TELECONSULTORIAS_ERRO_EXCLUIR_RESTRICAO_IDADE: 'TELECONSULTORIAS_ERRO_EXCLUIR_RESTRICAO_IDADE',
    TELECONSULTORIAS_EXCLUIR_RESTRICAO_IDADE: 'TELECONSULTORIAS_EXCLUIR_RESTRICAO_IDADE',
    TELECONSULTORIAS_ERRO_SALVAR_RESTRICAO_IDADE: 'TELECONSULTORIAS_ERRO_SALVAR_RESTRICAO_IDADE',
    TELECONSULTORIAS_SALVAR_RESTRICAO_IDADE: 'TELECONSULTORIAS_SALVAR_RESTRICAO_IDADE',
    TELECONSULTORIAS_ERRO_SALVAR_RESTRICAO_GENERO: 'TELECONSULTORIAS_ERRO_SALVAR_RESTRICAO_GENERO',
    TELECONSULTORIAS_SALVAR_RESTRICAO_GENERO: 'TELECONSULTORIAS_SALVAR_RESTRICAO_GENERO',
    TELECONSULTORIAS_ERRO_SALVAR_RESTRICAO_INSTITUICAO: 'TELECONSULTORIAS_ERRO_SALVAR_RESTRICAO_INSTITUICAO',
    TELECONSULTORIAS_SALVAR_RESTRICAO_INSTITUICAO: 'TELECONSULTORIAS_SALVAR_RESTRICAO_INSTITUICAO',
    TELECONSULTORIAS_ERRO_EXCLUIR_RESTRICAO_GENERO: 'TELECONSULTORIAS_ERRO_EXCLUIR_RESTRICAO_GENERO',
    TELECONSULTORIAS_EXCLUIR_RESTRICAO_GENERO: 'TELECONSULTORIAS_EXCLUIR_RESTRICAO_GENERO',
    TELECONSULTORIAS_ERRO_SALVAR_LIBERACAO_CBO: 'TELECONSULTORIAS_ERRO_SALVAR_LIBERACAO_CBO',
    TELECONSULTORIAS_SALVAR_LIBERACAO_CBO: 'TELECONSULTORIAS_SALVAR_LIBERACAO_CBO',
    TELECONSULTORIAS_ERRO_EXCLUIR_LIBERACAO_CBO: 'TELECONSULTORIAS_ERRO_EXCLUIR_LIBERACAO_CBO',
    TELECONSULTORIAS_EXCLUIR_LIBERACAO_CBO: 'TELECONSULTORIAS_EXCLUIR_LIBERACAO_CBO',
    TELECONSULTORIAS_ERRO_SALVAR_LIBERACAO_VISUALIZADOR: 'TELECONSULTORIAS_ERRO_SALVAR_LIBERACAO_VISUALIZADOR',
    TELECONSULTORIAS_SALVAR_LIBERACAO_VISUALIZADOR: 'TELECONSULTORIAS_SALVAR_LIBERACAO_VISUALIZADOR',
    TELECONSULTORIAS_ERRO_SALVAR_AGENDA_PERSONALIZADA: 'TELECONSULTORIAS_ERRO_SALVAR_AGENDA_PERSONALIZADA',
    TELECONSULTORIAS_SALVAR_AGENDA_PERSONALIZADA: 'TELECONSULTORIAS_SALVAR_AGENDA_PERSONALIZADA',
    TELECONSULTORIAS_ERRO_SALVAR_AGENDA_CIRURGICA: 'TELECONSULTORIAS_ERRO_SALVAR_AGENDA_CIRURGICA',
    TELECONSULTORIAS_SALVAR_AGENDA_CIRURGICA: 'TELECONSULTORIAS_SALVAR_AGENDA_CIRURGICA',
    TELECONSULTORIAS_ERRO_SALVAR_AGENDA_INTEGRAL: 'TELECONSULTORIAS_ERRO_SALVAR_AGENDA_INTEGRAL',
    TELECONSULTORIAS_SALVAR_AGENDA_INTEGRAL: 'TELECONSULTORIAS_SALVAR_AGENDA_INTEGRAL',
    TELECONSULTORIAS_ERRO_SALVAR_AGENDA_FILA_UNICA: 'TELECONSULTORIAS_ERRO_SALVAR_AGENDA_FILA_UNICA',
    TELECONSULTORIAS_SALVAR_AGENDA_FILA_UNICA: 'TELECONSULTORIAS_SALVAR_AGENDA_FILA_UNICA',
    TELECONSULTORIAS_ERRO_SALVAR_LIBERACAO_REGULADOR: 'TELECONSULTORIAS_ERRO_SALVAR_LIBERACAO_REGULADOR',
    TELECONSULTORIAS_SALVAR_LIBERACAO_REGULADOR: 'TELECONSULTORIAS_SALVAR_LIBERACAO_REGULADOR',
    TELECONSULTORIAS_ERRO_SALVAR_LIBERACAO_SOLICITANTE: 'TELECONSULTORIAS_ERRO_SALVAR_LIBERACAO_SOLICITANTE',
    TELECONSULTORIAS_SALVAR_LIBERACAO_SOLICITANTE: 'TELECONSULTORIAS_SALVAR_LIBERACAO_SOLICITANTE',
    TELECONSULTORIAS_ERRO_SALVAR_ESPECIFICACAO: 'TELECONSULTORIAS_ERRO_SALVAR_ESPECIFICACAO',
    TELECONSULTORIAS_SALVAR_ESPECIFICACAO: 'TELECONSULTORIAS_SALVAR_ESPECIFICACAO',
    TELECONSULTORIAS_ERRO_ATIVAR_INATIVAR_ESPECIFICACAO: 'TELECONSULTORIAS_ERRO_ATIVAR_INATIVAR_ESPECIFICACAO',
    TELECONSULTORIAS_ATIVAR_INATIVAR_ESPECIFICACAO: 'TELECONSULTORIAS_ATIVAR_INATIVAR_ESPECIFICACAO',
    TELECONSULTORIAS_ERRO_SALVAR_NUTRICAO: 'TELECONSULTORIAS_ERRO_SALVAR_NUTRICAO',
    TELECONSULTORIAS_SALVAR_NUTRICAO: 'TELECONSULTORIAS_SALVAR_NUTRICAO',
    TELECONSULTORIAS_SALVAR_INSUMO: 'TELECONSULTORIAS_SALVAR_INSUMO',
    TELECONSULTORIAS_ERRO_SALVAR_INSUMO: 'TELECONSULTORIAS_ERRO_SALVAR_INSUMO',
    TELECONSULTORIAS_ERRO_SALVAR_MEDICAMENTO: 'TELECONSULTORIAS_ERRO_SALVAR_MEDICAMENTO',
    TELECONSULTORIAS_SALVAR_MEDICAMENTO: 'TELECONSULTORIAS_SALVAR_MEDICAMENTO',

    //Alteração de funcionário
    ADMINISTRATIVO_PESQUISA_ALTERACAO_FUNCIONARIO: 'ADMINISTRATIVO_PESQUISA_ALTERACAO_FUNCIONARIO',
    ADMINISTRATIVO_ERRO_PESQUISA_ALTERACAO_FUNCIONARIO: 'ADMINISTRATIVO_ERRO_PESQUISA_ALTERACAO_FUNCIONARIO',

    // Alteração de paciente
    CORRECAO_PACIENTE: 'CORRECAO_PACIENTE',
    ADMINISTRATIVO_ALTERACAO_PACIENTE: 'ADMINISTRATIVO_ALTERACAO_PACIENTE',
    ADMINISTRATIVO_ERRO_ALTERACAO_PACIENTE: 'ADMINISTRATIVO_ERRO_ALTERACAO_PACIENTE',

    // Unificação de paciente
    ADMINISTRATIVO_UNIFICACAO_PACIENTE: 'ADMINISTRATIVO_UNIFICACAO_PACIENTE',
    ADMINISTRATIVO_ERRO_UNIFICACAO_PACIENTE: 'ADMINISTRATIVO_ERRO_UNIFICACAO_PACIENTE',

    //Triagem de auto-cadastro
    ADMINISTRATIVO_PESQUISA_TRIAGEM: 'ADMINISTRATIVO_PESQUISA_TRIAGEM',
    ADMINISTRATIVO_ERRO_PESQUISA_TRIAGEM: 'ADMINISTRATIVO_ERRO_PESQUISA_TRIAGEM',

    ADMINISTRATIVO_PESQUISA_DADOS_TRIAGEM: 'ADMINISTRATIVO_PESQUISA_DADOS_TRIAGEM',
    ADMINISTRATIVO_ERRO_PESQUISA_DADOS_TRIAGEM: 'ADMINISTRATIVO_ERRO_PESQUISA_DADOS_TRIAGEM',

    ADMINISTRATIVO_ACESSO_SOLICITACAO: 'ADMINISTRATIVO_ACESSO_SOLICITACAO',
    ADMINISTRATIVO_ERRO_ACESSO_SOLICITACAO: 'ADMINISTRATIVO_ERRO_ACESSO_SOLICITACAO',

    ADMINISTRATIVO_APROVACAO_SOLICITACAO: 'ADMINISTRATIVO_APROVACAO_SOLICITACAO',
    ADMINISTRATIVO_ERRO_APROVACAO_SOLICITACAO: 'ADMINISTRATIVO_ERRO_APROVACAO_SOLICITACAO',

    ADMINISTRATIVO_REJEITAR_SOLICITACAO: 'ADMINISTRATIVO_REJEITAR_SOLICITACAO',
    ADMINISTRATIVO_ERRO_REJEITAR_SOLICITACAO: 'ADMINISTRATIVO_ERRO_REJEITAR_SOLICITACAO',

    ADMINISTRATIVO_APROVAR_TRIAGEM_SOLICITACAO: 'ADMINISTRATIVO_APROVAR_TRIAGEM_SOLICITACAO',
    ADMINISTRATIVO_ERRO_APROVAR_TRIAGEM_SOLICITACAO: 'ADMINISTRATIVO_ERRO_APROVAR_TRIAGEM_SOLICITACAO',

    // CRUD de equipes de saúde da família (ESFs)
    ADMINISTRATIVO_PESQUISA_EQUIPES: 'ADMINISTRATIVO_PESQUISA_EQUIPES',
    ADMINISTRATIVO_ERRO_PESQUISA_EQUIPES: 'ADMINISTRATIVO_ERRO_PESQUISA_EQUIPES',
    ADMINISTRATIVO_CADASTRAR_EQUIPES: 'ADMINISTRATIVO_CADASTRAR_EQUIPES',
    ADMINISTRATIVO_ERRO_CADASTRAR_EQUIPES: 'ADMINISTRATIVO_ERRO_CADASTRAR_EQUIPES',

    //Redes de Telemedicina
    ADMINISTRATIVO_PESQUISA_REDE_TELEMEDICINA: 'ADMINISTRATIVO_PESQUISA_REDE_TELEMEDICINA',
    ADMINISTRATIVO_ERRO_PESQUISA_REDE_TELEMEDICINA: 'ADMINISTRATIVO_ERRO_PESQUISA_REDE_TELEMEDICINA',
    ADMINISTRATIVO_CADASTRAR_REDE_TELEMEDICINA: 'ADMINISTRATIVO_CADASTRAR_REDE_TELEMEDICINA',
    ADMINISTRATIVO_ERRO_CADASTRAR_REDE_TELEMEDICINA: 'ADMINISTRATIVO_ERRO_CADASTRAR_REDE_TELEMEDICINA',

    //Mensagens
    ADMINISTRATIVO_PESQUISA_MENSAGENS: 'ADMINISTRATIVO_PESQUISA_MENSAGENS',
    ADMINISTRATIVO_ERRO_PESQUISA_MENSAGENS: 'ADMINISTRATIVO_ERRO_PESQUISA_MENSAGENS',
    ADMINISTRATIVO_CADASTRAR_MENSAGENS: 'ADMINISTRATIVO_CADASTRAR_MENSAGENS',
    ADMINISTRATIVO_ERRO_CADASTRAR_MENSAGENS: 'ADMINISTRATIVO_ERRO_CADASTRAR_MENSAGENS',

    //Pacs
    ADMINISTRATIVO_PESQUISA_PACS: 'ADMINISTRATIVO_PESQUISA_PACS',
    ADMINISTRATIVO_ERRO_PESQUISA_PACS: 'ADMINISTRATIVO_ERRO_PESQUISA_PACS',
    ADMINISTRATIVO_CADASTRAR_PACS: 'ADMINISTRATIVO_CADASTRAR_PACS',
    ADMINISTRATIVO_ERRO_CADASTRAR_PACS: 'ADMINISTRATIVO_ERRO_CADASTRAR_PACS',

    // Apps
    ADMINISTRATIVO_PESQUISA_APPS: 'ADMINISTRATIVO_PESQUISA_APPS',
    ADMINISTRATIVO_ERRO_PESQUISA_APPS: 'ADMINISTRATIVO_ERRO_PESQUISA_APPS',
    ADMINISTRATIVO_CADASTRAR_APP: 'ADMINISTRATIVO_CADASTRAR_APP',
    ADMINISTRATIVO_ERRO_CADASTRAR_APP: 'ADMINISTRATIVO_ERRO_CADASTRAR_APP',

    // HELPDESK e TELEATENDIMENTO
    STT_WEB_ATENDIMENTO_CHAT_HELPDESK: 'STT_WEB_ATENDIMENTO_CHAT_HELPDESK',
    STT_WEB_ATENDIMENTO_CHAT_TELEATENDIMENTO: 'STT_WEB_ATENDIMENTO_CHAT_TELEATENDIMENTO',
    HELPDESK_ENCERRAR_ATENDIMENTO_ERRO: 'HELPDESK_ENCERRAR_ATENDIMENTO_ERRO',
    HELPDESK_INICIAR_ATENDIMENTO: 'HELPDESK_INICIAR_ATENDIMENTO',
    HELPDESK_ENCERRAR_ATENDIMENTO: 'HELPDESK_ENCERRAR_ATENDIMENTO',
    HELPDESK_ENVIAR_ANEXO: 'HELPDESK_ENVIAR_ANEXO',
    HELPDESK_EXCLUIR_ANEXO: 'HELPDESK_EXCLUIR_ANEXO',
    HELPDESK_SALVAR_REDE: 'HELPDESK_SALVAR_REDE',
    HELPDESK_SALVAR_RESPOSTA_RAPIDA: 'HELPDESK_SALVAR_RESPOSTA_RAPIDA',

    TELEATENDIMENTO_ENCERRAR_ATENDIMENTO_ERRO: 'TELEATENDIMENTO_ENCERRAR_ATENDIMENTO_ERRO',
    CONECTA_ENCERRAR_EVENTO_ERRO: 'CONECTA_ENCERRAR_EVENTO_ERRO',
    TELEATENDIMENTO_ERRO_SALVAR_MOVIMENTACAO: 'TELEATENDIMENTO_ERRO_SALVAR_MOVIMENTACAO',
    TELEATENDIMENTO_SALVAR_AGENDAMENTO: 'TELEATENDIMENTO_SALVAR_AGENDAMENTO',
    TELEATENDIMENTO_CANCELAR_AGENDAMENTO: 'TELEATENDIMENTO_CANCELAR_AGENDAMENTO',
    TELEATENDIMENTO_ENCERRAR_AGENDAMENTO: 'TELEATENDIMENTO_ENCERRAR_AGENDAMENTO',
    TELEATENDIMENTO_ATUALIZAR_AGENDAMENTO: 'TELEATENDIMENTO_ATUALIZAR_AGENDAMENTO',
    TELEATENDIMENTO_SALVAR_CONSULTORIO: 'TELEATENDIMENTO_SALVAR_CONSULTORIO',
    TELEATENDIMENTO_SALVAR_AREA: 'TELEATENDIMENTO_SALVAR_AREA',
    TELEATENDIMENTO_SALVAR_MOTIVO_CANCELAMENTO: 'TELEATENDIMENTO_SALVAR_MOTIVO_CANCELAMENTO',
    TELEATENDIMENTO_SALVAR_MOTIVO_ENCERRAMENTO: 'TELEATENDIMENTO_SALVAR_MOTIVO_ENCERRAMENTO',
    TETELEATENDIMENTO_SALVAR_RESPOSTA_RAPIDA: 'TELEATENDIMENTO_SALVAR_RESPOSTA_RAPIDA',
    TELEATENDIMENTO_SALVAR_SITUACAO_CONSULTORIO: 'TELEATENDIMENTO_SALVAR_SITUACAO_CONSULTORIO',
    TELEATENDIMENTO_SALVAR_SITUACAO_MOTIVO_CANCELAMENTO: 'TELEATENDIMENTO_SALVAR_SITUACAO_MOT_CANCELAMENTO',
    TELEATENDIMENTO_SALVAR_SITUACAO_MOTIVO_ENCERRAMENTO: 'TELEATENDIMENTO_SALVAR_SITUACAO_MOT_ENCERRAMENTO',
    TELEATENDIMENTO_SALVAR_SITUACAO_RESPOSTA_RAPIDA: 'TELEATENDIMENTO_SALVAR_SITUACAO_RESPOSTA_RAPIDA',

    //ELETROCARDIOGRAFIA
    ELETROCARDIOGRAFIA_SOLICITAR: 'ELETROCARDIOGRAFIA_SOLICITAR',
    ELETROCARDIOGRAFIA_ERRO_SOLICITAR: 'ELETROCARDIOGRAFIA_ERRO_SOLICITAR',
    ELETROCARDIOGRAFIA_INSERCAO_EXAME_DUPLICADO: 'ELETROCARDIOGRAFIA_INSERCAO_EXAME_DUPLICADO',
    ELETROCARDIOGRAFIA_INSERCAO_EXAME_IMAGEM_SIMILAR: 'ELETROCARDIOGRAFIA_INSERCAO_EXAME_IMAGEM_SIMILAR',

    // CATEGORIAS DE LOG
    CATEGORIA: {
        PRIORIZACAO_EXAME: 1,
        INVALIDACAO_EXAME: 5,
        REENVIO_SENHA: 2,
        CADASTRO_USUARIO: 3,
        ALTERACAO_USUARIO: 4,
        INVALIDAR_EXAME: 5,
        CADASTRO_EQUIPE: 6,
        CADASTRO_EQUIPAMENTO: 7,
        CADASTRO_FUNCIONARIO: 8,
        ALTERACAO_FUNCIONARIO: 9,
        ATENDIMENTO_FUNCIONARIO_HELPDESK: 10,
        ATENDIMENTO_PACIENTE_HELPDESK: 11,
        CADASTRO_INSTITUICAO: 12,
        PACIENTE_VINCULADO_EXAME: 13,
        SOLICITANTE_VINCULADO_EXAME: 14,
        EXAME_GERIR: 15,
    },

    // ALOFONO
    ALOFONO_ERRO_INICIAR: 'ALOFONO_ERRO_INICIAR',
    ALOFONO_ERRO_FINALIZAR: 'ALOFONO_ERRO_FINALIZAR',
    ALOFONO_ERRO_SALVAR_ITERACAO: 'ALOFONO_ERRO_SALVAR_ITERACAO',
    ALOFONO_ERRO_SALVAR_QUESTIONARIO: 'ALOFONO_ERRO_SALVAR_QUESTIONARIO',

    TELEATENDIMENTO_ACESSO: 'TELEATENDIMENTO_ACESSO',
    TELEATENDIMENTO_ACESSO_ANEXO: 'TELEATENDIMENTO_ACESSO_ANEXO',
    TELEATENDIMENTO_SAIDA: 'TELEATENDIMENTO_SAIDA',
    TELEATENDIMENTO_SELECAO_PACIENTE: 'TELEATENDIMENTO_SELECAO_PACIENTE',
    TELEATENDIMENTO_TRIAGEM_PACIENTE_AGENDADO: 'TELEATENDIMENTO_TRIAGEM_PACIENTE_AGENDADO',
    TELEATENDIMENTO_AUDIO_VIDEO: 'TELEATENDIMENTO_AUDIO_VIDEO',
    TELEATENDIMENTO_ENVIO_ANEXO: 'TELEATENDIMENTO_ENVIO_ANEXO',
    TELEATENDIMENTO_ENVIO_REGISTRO: 'TELEATENDIMENTO_ENVIO_REGISTRO',
    TELEATENDIMENTO_FINALIZADO: 'TELEATENDIMENTO_FINALIZADO',
    TELEATENDIMENTO_ENCAMINHADO: 'TELEATENDIMENTO_ENCAMINHADO',

    TELESSAUDE_WEB_ACESSO_CURSO: 'TELESSAUDE_WEB_ACESSO_CURSO',
    TELESSAUDE_WEB_ACESSO_CURSO_ERRO: 'TELESSAUDE_WEB_ACESSO_CURSO_ERRO',
    TELESSAUDE_WEB_ACESSO_EVENTOS_ANDAMENTO: 'TELESSAUDE_WEB_ACESSO_EVENTOS_ANDAMENTO',
    TELESSAUDE_WEB_REGISTRO_ACESSO_WEB: 'TELESSAUDE_WEB_REGISTRO_ACESSO_WEB',

    // TELE-EDUCAÇÃO
    TELE_EDUCACAO_BAIXAR_MATERIAL: 'TELE_EDUCACAO_BAIXAR_MATERIAL',
    PESQUISAR_WEBCONFERENCIA: 'PESQUISAR_WEBCONFERENCIA',
    ERRO_PESQUISAR_WEBCONFERENCIA: 'ERRO_PESQUISAR_WEBCONFERENCIA',
    WEBCONFERENCIA_SALVAR: 'WEBCONFERENCIA_SALVAR',
    WEBCONFERENCIA_ERRO_SALVAR: 'WEBCONFERENCIA_ERRO_SALVAR',
    TELE_EDUCACAO_SALVAR_MATERIAL: 'TELE_EDUCACAO_SALVAR_MATERIAL',
    TELE_EDUCACAO_ERRO_SALVAR_MATERIAL: 'TELE_EDUCACAO_ERRO_SALVAR_MATERIAL',
    TELE_EDUCACAO_REMOCAO_ACESSO: 'TELE_EDUCACAO_REMOCAO_ACESSO',
    TELE_EDUCACAO_ERRO_REMOCAO_ACESSO: 'TELE_EDUCACAO_ERRO_REMOCAO_ACESSO',
    TELE_EDUCACAO_INATIVAR: 'TELE_EDUCACAO_INATIVAR',
    TELE_EDUCACAO_ERRO_INATIVAR: 'TELE_EDUCACAO_ERRO_INATIVAR',
    PESQUISAR_CURSO: 'PESQUISAR_CURSO',
    ERRO_PESQUISAR_CURSO: 'ERRO_PESQUISAR_CURSO',
    CURSO_SALVAR: 'CURSO_SALVAR',
    CURSO_ERRO_SALVAR: 'CURSO_ERRO_SALVAR',
    IMPRIMIR_DECLARACAO: 'IMPRIMIR_DECLARACAO',
    ERRO_IMPRIMIR_DECLARACAO: 'ERRO_IMPRIMIR_DECLARACAO',
    IMPRIMIR_CERTIFICADO: 'IMPRIMIR_CERTIFICADO',
    ERRO_IMPRIMIR_CERTIFICADO: 'ERRO_IMPRIMIR_CERTIFICADO',

    // SISTEMA
    CADASTRO_FUNCIONARIO_SISTEMA: 'CADASTRO_FUNCIONARIO_SISTEMA',
    ERRO_CADASTRO_FUNCIONARIO_SISTEMA: 'ERRO_CADASTRO_FUNCIONARIO_SISTEMA',
    CADASTRO_TELE_0800_SISTEMA: 'CADASTRO_TELE_0800_SISTEMA',
    ERRO_CADASTRO_TELE_0800_SISTEMA: 'ERRO_CADASTRO_TELE_0800_SISTEMA',
    CADASTRO_TELE_CC_SISTEMA: 'CADASTRO_TELE_CC_SISTEMA',
    ERRO_CADASTRO_TELE_CC_SISTEMA: 'ERRO_CADASTRO_TELE_CC_SISTEMA',
    CADASTRO_TELE_SOLICITACAO_SISTEMA: 'CADASTRO_TELE_SOLICITACAO_SISTEMA',
    ERRO_CADASTRO_TELE_SOLICITACAO_SISTEMA: 'ERRO_CADASTRO_TELE_SOLICITACAO_SISTEMA',

    // APAC
    PESQUISAR_PROCESSO_APAC: 'STT2_WEB_PESQUISAR_PROCESSO_APAC',
    ERRO_PESQUISAR_PROCESSO_APAC: 'STT2_WEB_ERRO_PESQUISAR_PROCESSO_APAC',
    BAIXAR_ARQUIVO_APAC: 'STT2_WEB_BAIXAR_ARQUIVO_APAC',
    ERRO_BAIXAR_ARQUIVO_APAC: 'STT2_WEB_ERRO_BAIXAR_ARQUIVO_APAC',
    INICIAR_NOVA_APAC: 'STT2_WEB_INICIAR_NOVA_APAC',
    ERRO_INICIAR_NOVA_APAC: 'STT2_WEB_ERRO_INICIAR_NOVA_APAC',
    EDITAR_APAC: 'STT2_WEB_EDITAR_APAC',
    ERRO_EDITAR_APAC: 'STT2_WEB_ERRO_EDITAR_APAC',
    ENCAMINHAR_APAC: 'STT2_WEB_ENCAMINHAR_APAC',
    ERRO_ENCAMINHAR_APAC: 'STT2_WEB_ERRO_ENCAMINHAR_APAC',
    IMPRIMIR_APAC: 'STT2_WEB_IMPRIMIR_APAC',
    ERRO_IMPRIMIR_APAC: 'STT2_WEB_ERRO_IMPRIMIR_APAC',
    CANCELAMENTO_APAC: 'STT2_WEB_CANCELAMENTO_APAC',
    ERRO_CANCELAMENTO_APAC: 'STT2_WEB_ERRO_CANCELAMENTO_APAC',
    ERRO_PESQUISA_MOTIVOS_DEVOLUCAO_APAC: 'STT2_WEB_ERRO_PESQUISA_MOTIVOS_DEVOLUCAO_APAC',
    DEVOLUCAO_APAC: 'STT2_WEB_DEVOLUCAO_APAC',
    ERRO_DEVOLUCAO_APAC: 'STT2_WEB_ERRO_DEVOLUCAO_APAC',
    AUTORIZAR_APAC: 'STT2_WEB_AUTORIZAR_APAC',
    ERRO_AUTORIZAR_APAC: 'STT2_WEB_ERRO_AUTORIZAR_APAC',
    ENCAMINHAR_AUTORIZADOR: 'STT2_WEB_ENCAMINHAR_AUTORIZADOR',
    ERRO_ENCAMINHAR_AUTORIZADOR: 'STT2_WEB_ERRO_ENCAMINHAR_AUTORIZADOR',
    APROVACAO_APAC: 'STT2_WEB_APROVACAO_APAC',
    ERRO_APROVACAO_APAC: 'STT2_WEB_ERRO_APROVACAO_APAC',
    INVALIDACAO_APAC: 'STT2_WEB_INVALIDACAO_APAC',
    ERRO_INVALIDACAO_APAC: 'STT2_WEB_ERRO_INVALIDACAO_APAC',

    // RSE
    PESQUISAR_PROCESSO_RSE: 'STT2_WEB_PESQUISAR_PROCESSO_RSE',
    ERRO_PESQUISAR_PROCESSO_RSE: 'STT2_WEB_ERRO_PESQUISAR_PROCESSO_RSE',
    BAIXAR_ARQUIVO_RSE: 'STT2_WEB_BAIXAR_ARQUIVO_RSE',
    ERRO_BAIXAR_ARQUIVO_RSE: 'STT2_WEB_ERRO_BAIXAR_ARQUIVO_RSE',
    INICIAR_NOVA_RSE: 'STT2_WEB_INICIAR_NOVA_RSE',
    ERRO_INICIAR_NOVA_RSE: 'STT2_WEB_ERRO_INICIAR_NOVA_RSE',
    EDITAR_RSE: 'STT2_WEB_EDITAR_RSE',
    ERRO_EDITAR_RSE: 'STT2_WEB_ERRO_EDITAR_RSE',
    ENCAMINHAR_RSE: 'STT2_WEB_ENCAMINHAR_RSE',
    ERRO_ENCAMINHAR_RSE: 'STT2_WEB_ERRO_ENCAMINHAR_RSE',
    IMPRIMIR_RSE: 'STT2_WEB_IMPRIMIR_RSE',
    ERRO_IMPRIMIR_RSE: 'STT2_WEB_ERRO_IMPRIMIR_RSE',
    CANCELAMENTO_RSE: 'STT2_WEB_CANCELAMENTO_RSE',
    ERRO_CANCELAMENTO_RSE: 'STT2_WEB_ERRO_CANCELAMENTO_RSE',
    ERRO_PESQUISA_MOTIVOS_DEVOLUCAO_RSE: 'STT2_WEB_ERRO_PESQUISA_MOTIVOS_DEVOLUCAO_RSE',
    DEVOLUCAO_RSE: 'STT2_WEB_DEVOLUCAO_RSE',
    ERRO_DEVOLUCAO_RSE: 'STT2_WEB_ERRO_DEVOLUCAO_RSE',
    AUTORIZAR_RSE: 'STT2_WEB_AUTORIZAR_RSE',
    ERRO_AUTORIZAR_RSE: 'STT2_WEB_ERRO_AUTORIZAR_RSE',
    ENCAMINHAR_AUTORIZADOR: 'STT2_WEB_ENCAMINHAR_AUTORIZADOR',
    ERRO_ENCAMINHAR_AUTORIZADOR: 'STT2_WEB_ERRO_ENCAMINHAR_AUTORIZADOR',
    APROVACAO_RSE: 'STT2_WEB_APROVACAO_RSE',
    ERRO_APROVACAO_RSE: 'STT2_WEB_ERRO_APROVACAO_RSE',
    INVALIDACAO_RSE: 'STT2_WEB_INVALIDACAO_RSE',
    ERRO_INVALIDACAO_RSE: 'STT2_WEB_ERRO_INVALIDACAO_RSE',
    FINALIZACAO_COMPROVACAO_SERVICO_RSE: 'STT2_WEB_FINALIZACAO_COMPROVACAO_SERVICO_RSE',
    ERRO_FINALIZACAO_COMPROVACAO_SERVICO_RSE: 'STT2_WEB_ERRO_FINALIZACAO_COMPROVACAO_SERVICO_RSE',


    // CONECTA
    CONECTA_SALVAR_REDE: 'CONECTA_SALVAR_REDE',
    CONECTA_ERRO_SALVAR_REDE: 'CONECTA_ERRO_SALVAR_REDE',
    CONECTA_SALVAR_AGENDA_REDE: 'CONECTA_SALVAR_AGENDA_REDE',
    CONECTA_ERRO_SALVAR_AGENDA_REDE: 'CONECTA_ERRO_SALVAR_AGENDA_REDE',
    CONECTA_SALVAR_CATEGORIA: 'CONECTA_SALVAR_CATEGORIA',
    CONECTA_ERRO_SALVAR_CATEGORIA: 'CONECTA_ERRO_SALVAR_CATEGORIA',
    CONECTA_SALVAR_MOTIVO_CANCELAMENTO: 'CONECTA_SALVAR_MOTIVO_CANCELAMENTO',
    CONECTA_ERRO_SALVAR_MOTIVO_CANCELAMENTO: 'CONECTA_ERRO_SALVAR_MOTIVO_CANCELAMENTO',
    CONECTA_SALVAR_AGENDAMENTO: 'CONECTA_SALVAR_AGENDAMENTO',
    CONECTA_ERRO_SALVAR_AGENDAMENTO: 'CONECTA_ERRO_SALVAR_AGENDAMENTO',
    CONECTA_ERRO_SALVAR_MOVIMENTACAO_AGENDAMENTO: 'CONECTA_ERRO_SALVAR_MOVIMENTACAO_AGENDAMENTO',
    CONECTA_CANCELAR_AGENDAMENTO: 'CONECTA_CANCELAR_AGENDAMENTO',
    CONECTA_ERRO_CANCELAR_AGENDAMENTO: 'CONECTA_ERRO_CANCELAR_AGENDAMENTO',
    CONECTA_ACEITAR_RECUSAR_AGENDAMENTO: 'CONECTA_ACEITAR_RECUSAR_AGENDAMENTO',
    CONECTA_ERRO_ACEITAR_RECUSAR_AGENDAMENTO: 'CONECTA_ERRO_ACEITAR_RECUSAR_AGENDAMENTO',
    CONECTA_EVENTO_ACESSO: 'CONECTA_EVENTO_ACESSO',
    CONECTA_EVENTO_ACESSO_ANEXO: 'CONECTA_EVENTO_ACESSO_ANEXO',
    CONECTA_EVENTO_SAIDA: 'CONECTA_EVENTO_SAIDA',
    CONECTA_EVENTO_AUDIO_VIDEO: 'CONECTA_EVENTO_AUDIO_VIDEO',
    CONECTA_EVENTO_ENVIO_ANEXO: 'CONECTA_EVENTO_ENVIO_ANEXO',
    CONECTA_EVENTO_FINALIZADO: 'CONECTA_EVENTO_FINALIZADO',

    // OXIGENOTERAPIA
    IMPRIMIR_AVALIACAO_CLINICA: 'STT2_WEB_IMPRIMIR_AVALIACAO_CLINICA',
    ERRO_IMPRIMIR_AVALIACAO_CLINICA: 'STT2_WEB_ERRO_IMPRIMIR_AVALIACAO_CLINICA',
    BAIXAR_ARQUIVO_AVALIACAO_CLINICA: 'STT2_WEB_BAIXAR_ARQUIVO_AVALIACAO_CLINICA',
    ERRO_BAIXAR_ARQUIVO_AVALIACAO_CLINICA: 'STT2_WEB_ERRO_BAIXAR_ARQUIVO_AVALIACAO_CLINICA',

    GERAR_GAS_AVALIACAO_CLINICA: 'STT2_WEB_GERAR_GAS_AVALIACAO_CLINICA',
    ERRO_GERAR_GAS_AVALIACAO_CLINICA: 'STT2_WEB_ERRO_GERAR_GAS_AVALIACAO_CLINICA',
    IMPRIMIR_GAS_AVALIACAO_CLINICA: 'STT2_WEB_IMPRIMIR_GAS_AVALIACAO_CLINICA',
    ERRO_IMPRIMIR_GAS_AVALIACAO_CLINICA: 'STT2_WEB_ERRO_IMPRIMIR_GAS_AVALIACAO_CLINICA',

    // INTEGRAÇÃO
    API_INTEGRACAO_TDIAG_SOLICITACAO_HOSPITALAR: 'API_INTEGRACAO_TDIAG_SOLICITACAO_HOSPITALAR',
    API_INTEGRACAO_ERRO_TDIAG_SOLICITACAO_HOSPITALAR: 'API_INTEGRACAO_ERRO_TDIAG_SOLICITACAO_HOSPITALAR',

    // ASSINATURA DIGITAL
    ASSINATURA_DIGITAL_TOKEN: 'ASSINATURA_DIGITAL_TOKEN',
    ASSINATURA_DIGITAL_ASSINATURA: 'ASSINATURA_DIGITAL_ASSINATURA',

    // CONTRARREFERÊNCIA
    CONTRARREFERENCIA_SALVAR: 'CONTRARREFERENCIA_SALVAR',
    CONTRARREFERENCIA_ERRO_SALVAR: 'CONTRARREFERENCIA_ERRO_SALVAR',
    CONTRARREFERENCIA_CANCELAR: 'CONTRARREFERENCIA_CANCELAR',
    CONTRARREFERENCIA_ERRO_CANCELAR: 'CONTRARREFERENCIA_ERRO_CANCELAR',
    CONTRARREFERENCIA_ASSINATURA_DIGITAL: 'CONTRARREFERENCIA_ASSINATURA_DIGITAL',
    CONTRARREFERENCIA_ERRO_ASSINATURA_DIGITAL: 'CONTRARREFERENCIA_ERRO_ASSINATURA_DIGITAL',

    // BUSCA-ATIVA
    IMPRIMIR_RONDA: 'STT2_WEB_IMPRIMIR_RONDA',
    ERRO_IMPRIMIR_RONDA: 'STT2_WEB_ERRO_IMPRIMIR_RONDA',
    IMPRIMIR_INFORMATIVO_OBITO: 'STT2_WEB_IMPRIMIR_INFORMATIVO_OBITO',
    ERRO_IMPRIMIR_INFORMATIVO_OBITO: 'STT2_WEB_ERRO_IMPRIMIR_INFORMATIVO_OBITO',

    MOODLE: {
        ERROS: {
            GET_CURSOS: {
                BAD_REQUEST: 'MOODLE_GET_CURSOS_BAD_REQUEST',
                NOT_FOUND: 'MOODLE_GET_CURSOS_NOT_FOUND',
                INTERNAL_SERVER_ERROR: 'MOODLE_GET_CURSOS_INTERNAL_SERVER_ERROR',
                UNAUTHORIZED: 'MOODLE_GET_CURSOS_UNAUTHORIZED',
                FORBIDDEN: 'MOODLE_GET_CURSOS_FORBIDDEN'
            }
        }
    }

};

const REDIS = {
    OAUTH2: 0,
    TELEATENDIMENTO: 1,
    ANALISE_AGENDADOR: 2,
    HELPDESK: 3,
    CONECTA: 4,
    GESTAO_PACS: 5,
    PACIENTE_HUB: 6,
    EXAMES_INTEGRACAO: 7,
    TELEATENDIMENTO_FHIR: 8,
    MENSAGENS: 9,
    TELE_EDUCACAO: 10
};

/**
 * Esses status são utilizados para controle do processamento e enviados como notificação para o NATS.io.
 */
const PACS_INTEGRACAO = {
    // Status para comando Estudo Dicom
    STATUS_NA_FILA: 0,
    STATUS_EM_PROCESSAMENTO: 1,
    STATUS_PROCESSADO: 2,
    STATUS_ERRO: -1,

    // Status para comando invalidacao
    STATUS_INVALIDADO: 10,
    STATUS_INVALIDACAO_EM_PROCESSAMENTO: 11,
    STATUS_AGUARDANDO_INVALIDACAO: 12,
    STATUS_ERRO_INVALIDACAO: -10,

    // Status para comando migração @deprecated
    STATUS_MIGRACAO_EM_PROCESSAMENTO: 21,
    STATUS_MIGRACAO_PROCESSADO: 22,
    STATUS_ERRO_MIGRACAO: -21,

    // Status para comando updicom
    STATUS_UPDICOM_NA_FILA: 30,
    STATUS_UPDICOM_EM_PROCESSAMENTO: 31,
    STATUS_ERRO_UPDICOM: -31,
    STATUS_UPDICOM_PROCESSADO: 32,

    // Status para comando restaurar
    STATUS_RESTAURACAO_NA_FILA: 40,
    STATUS_RESTAURACAO_EM_PROCESSAMENTO: 41,
    STATUS_RESTAURACAO_PROCESSADO: 42,
    STATUS_ERRO_RESTAURACAO: -40
};

const STATUS_COMANDOS = {
    invalidacao: {
        '': 'Processando',
        'sucesso.stt': 'Sucesso Parcial',
        'sucesso.bridge': 'Sucesso Parcial',
        'sucesso.ambos': 'Sucesso',
        sucesso: 'Sucesso',
        'erro.stt': 'Erro',
        'erro.bridge': 'Erro',
        'erro.ambos': 'Erro',
        erro: 'Erro'
    },
    exclusao: {
        '': 'Processando',
        'processando.bridge': 'Processando',
        'processando.stt': 'Processando',
        'processando.ambos': 'Processando',
        'sucesso.stt': 'Sucesso Parcial',
        'sucesso.bridge': 'Sucesso Parcial',
        'sucesso.ambos': 'Sucesso',
        sucesso: 'Sucesso',
        'erro.stt': 'Erro',
        'erro.bridge': 'Erro',
        'erro.ambos': 'Erro',
        erro: 'Erro'
    },
    agendado: {
        '': 'Processando',
        'sucesso.api': 'Sucesso Parcial',
        'sucesso.bridge': 'Sucesso Parcial',
        sucesso: 'Sucesso',
        erro: 'Erro'
    },
    rename: {
        '': 'Processando',
        'sucesso.stt': 'Sucesso Parcial',
        'sucesso.bridge': 'Sucesso Parcial',
        'sucesso.ambos': 'Sucesso',
        sucesso: 'Sucesso',
        'erro.stt': 'Erro',
        'erro.bridge': 'Erro',
        'erro.ambos': 'Erro',
        erro: 'Erro'
    },
    updicom: {
        '': 'Processando',
        processando: 'Processando',
        sucesso: 'Sucesso',
        erro: 'Erro'
    },
    restaurar: {
        '': 'Processando',
        processando: 'Processando',
        'sucesso.stt': 'Sucesso',
        'sucesso.ambos': 'Sucesso',
        'sucesso.bridge': 'Sucesso Parcial',
        sucesso: 'Sucesso',
        erro: 'Erro'
    },
    ping: {
        '': 'Processando',
        sucesso: 'Sucesso',
        erro: 'Erro'
    }
};

const STATUS_INTEGRACAO_DESCRICOES = {
    0: 'Na fila',
    1: 'Em processamento',
    2: 'Processado',
    '-1': 'Erro',
    10: 'Invalidado',
    11: 'Invalidação em processamento',
    '-10': 'Erro na invalidação',
    21: 'Migração em processamento',
    22: 'Migração processado',
    '-21': 'Erro na migração'
};

const STATUS_INTEGRACAO_INVALIDACAO = {
    INVALIDACAO_EM_PROCESSAMENTO: 11,
    INVALIDADO: 10,
    ERRO_NA_INVALIDACAO: -10
};

const STATUS_INTEGRACAO_ESTUDO_DICOM = {
    NA_FILA: 0,
    EM_PROCESSAMENTO: 1,
    PROCESSADO: 2,
    ERRO: -1
};

const STATUS_RECUPERACAO_EXAME = {
    NA_FILA: 'Na fila',
    EM_EXECUCAO: 'Em execução',
    COMPLETO: 'Completo',
    FALHA: 'Falha'
};

const TIPOS_SENHA = {
    NOME: 'nome',
    CPF: 'cpf',
    DATA: 'dataNascimento',
    EMAIL: 'email',
    LOGIN: 'login'
};

const EXTENSAO = {
    PDF: 'pdf',
    JPG: 'jpg',
    PNG: 'png',
    XLS: 'xls',
    XLSX: 'xlsx',
    DOC: 'doc',
    DOCX: 'DOCX',
    AI: 'ai',
    NAO_RECONHECIDO: '****',
    ALTURA_PDF_ANEXO: 1280,
    LARGURA_PDF_ANEXO: 720
}


module.exports = {
    TIPOS_SENHA,
    PESQUISA,
    SITUACAO_EXAME,
    SITUACAO_LAUDO,
    PERFIL,
    PERMISSAO,
    TIPO_CONTATO,
    LOG,
    REDIS,
    MODULOS_EXAME,
    PACS_INTEGRACAO,
    STATUS_COMANDOS,
    STATUS_INTEGRACAO_DESCRICOES,
    STATUS_INTEGRACAO_ESTUDO_DICOM,
    STATUS_INTEGRACAO_INVALIDACAO,
    STATUS_RECUPERACAO_EXAME,
    EXTENSAO
};
